
var overviewData = {
  "headline": "CPH Highline 360",
  "subtext": "Oplev Cph Highline i 3D. Klik på de fem hot spots og tag en tur rundt i byggeriet.",
  "poiCollections": [
    {
      "points": [
        {
          "x": 0.08789937674822801,
          "y": 0.26736441484300666,
          "headline": "K\u00f8dbyen",
          "subtext": "600 m",
          "tintColor": "orange"
        },
        {
          "x": 0.19145039981817052,
          "y": 0.20173745173745175,
          "headline": "R\u00e5dhuspladsen",
          "subtext": "980 m",
          "tintColor": "orange"
        },
        {
          "x": 0.23443997971720829,
          "y": 0.21122740247383445,
          "headline": "Str\u00f8get",
          "subtext": "1.2 km",
          "tintColor": "orange"
        },
        {
          "x": 0.2691719509545664,
          "y": 0.22835394862036157,
          "headline": "Tivoli",
          "subtext": "940 m",
          "tintColor": "orange"
        },
        {
          "x": 0.30243920240067346,
          "y": 0.21693625118934348,
          "headline": "Kgs Nytorv",
          "subtext": "2 km",
          "tintColor": "orange"
        },
        {
          "x": 0.3847416972819484,
          "y": 0.20923076923076922,
          "headline": "Christiansborg",
          "subtext": "1.5 km",
          "tintColor": "orange"
        },
        {
          "x": 0.4436552901719034,
          "y": 0.21217887725975262,
          "headline": "Nyhavn",
          "subtext": "2 km",
          "tintColor": "orange"
        },
        {
          "x": 0.6317170993672433,
          "y": 0.2274024738344434,
          "headline": "Christianshavn",
          "subtext": "2 km",
          "tintColor": "orange"
        },
        {
          "x": 0.7912641216087771,
          "y": 0.21883920076117983,
          "headline": "Amager",
          "subtext": "2 km",
          "tintColor": "orange"
        },
        {
          "x": 0.9147890188381901,
          "y": 0.7044989775051125,
          "headline": "Havnemilj\u00f8",
          "subtext": "25 m",
          "tintColor": "orange"
        }
      ],
      "layerName": "culture"
    },
    {
      "points": [
        {
          "x": 0.14085540966243923,
          "y": 0.3263558515699334,
          "headline": "Dybb\u00f8lsbro st.",
          "subtext": "530 m",
          "tintColor": "green"
        },
        {
          "x": 0.1401764861635391,
          "y": 0.23977164605137963,
          "headline": "Hovedbaneg\u00e5rden",
          "subtext": "920 m",
          "tintColor": "green"
        },
        {
          "x": 0.06534096836336577,
          "y": 0.6355851569933397,
          "headline": "Bus",
          "subtext": "25 m",
          "tintColor": "green"
        },
        {
          "x": 0.3058338198951742,
          "y": 0.3558515699333968,
          "headline": "Bus",
          "subtext": "100 m",
          "tintColor": "green"
        },
        {
          "x": 0.5029367200122824,
          "y": 0.23596574690770694,
          "headline": "H.C.A. Boulevard",
          "subtext": "1 km",
          "tintColor": "green"
        }
      ],
      "layerName": "transport"
    }
  ]
};
